import MDinput from '@/components/MDinput';
import AddressInput from '@/components/DSE/AddressInput';
import { validatorEmail, validatorRequire } from '@/utils/validators';
import TimestampedRTE from '@/components/TimestampedRTE';
import CrudContactPerson from '../components/CrudContactPerson';
import CrudLinkStoreCollection from '../components/CrudLinkStoreCollection';
import Select from '@/components/DSE/Select';
import TimeRangePicker from '@/components/DSE/TimeRangePicker';
import InputNumber from '@/components/DSE/InputNumber';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, true, false, false], // Tab 1, tab 2, ....
    labels: ['store.tabGeneral', 'common.transport', 'store.tabContactPersons', 'store.tabStoreCollections'],
    headerTemplate: (str, form) => `
    <h3>
    ${form.name || ''}
    </h3>
    `,
    groups: [
      // Tab 1
      {
        name: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 64,
            required: true
          },
          rules: [
            {
              validator: validatorRequire
            }
          ]
        },
        code: {
          type: MDinput,
          defaultValue: null,
          props: {
            maxlength: 16,
            caption: 'store.code'
          }
        },
        description: {
          type: MDinput,
          defaultValue: '',
          props: {
            maxlength: 255
          }
        },
        source: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'order.source',
            maxlength: 32
          }
        },
        storeAttributeID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'store.attribute',
            valueField: 'id',
            labelField: 'name',
            loading: vue.$store.getters['storeAttribute/isLoading'],
            options: vue.$store.getters['storeAttribute/loadedItems']
          }
        },
        storeTypeID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'store.type',
            valueField: 'id',
            labelField: 'name',
            loading: vue.$store.getters['storeType/isLoading'],
            options: vue.$store.getters['storeType/loadedItems']
          }
        },
        height: {
          type: InputNumber,
          props: {
            caption: 'store.height'
          }
        },
        address: {
          type: AddressInput,
          defaultValue: null,
          props: {
            countries: vue.$store.getters['country/loadedItems'],
            countriesLoading: vue.$store.getters['country/isLoading']
          }
        },
        email: {
          type: MDinput,
          props: {
            type: 'email',
            maxlength: 64
          },
          rules: [{ validator: validatorEmail }]
        },
        phone: {
          type: MDinput,
          props: {
            type: 'tel'
          }
        },
        globalLocationNumber: {
          type: MDinput,
          defaultValue: null,
          props: {
            maxlength: 13
          }
        },
        remarks: {
          type: TimestampedRTE,
          defaultValue: '',
          props: {
            caption: 'common.remarks'
          }
        },
        debtorNumber: {
          type: MDinput,
          defaultValue: '',
          props: {
            caption: 'common.debtorNumber',
            maxlength: 18
          }
        }
      },
      // Tab 2 Transport
      {
        unloadingAddressCode: {
          type: MDinput,
          props: {
            caption: 'transport.unloadingAddressCode',
            maxlength: 8
          }
        },
        unloadingTimeRange: {
          type: TimeRangePicker,
          props: {
            caption: 'transport.unloadingTimeRange',
            format: 'hh:mm'
          }
        }
      },
      // Tab 3
      {
        contactPersons: {
          type: CrudContactPerson,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'storeID',
            permissionCode: 'Store'
          }
        }
      },
      // Tab 4
      {
        collections: {
          type: CrudLinkStoreCollection,
          defaultValue: [],
          props: {
            caption: 'common.emptyString',
            openInFullscreen: false,
            parentIdFilterField: 'storeID',
            permissionCode: 'Store'
          },
          dynamicProps: form => ({
            domainID: form.domainID
          })
        }
      }
    ]
  };
}

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 50,
      fields: ['name', 'code', 'description', 'source', 'debtorNumber', 'storeAttributeID', 'storeTypeID', 'height']
    },
    {
      width: 50,
      fields: ['address', 'email', 'phone', 'globalLocationNumber']
    },
    {
      width: 100,
      fields: ['remarks']
    }
  ]
};
const layoutFullWidth = {
  sections: [
    {
      width: 100
    }
  ]
};

export function getCreateLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutFullWidth]
  };
}
export function getEditLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutFullWidth, layoutFullWidth, layoutFullWidth]
  };
}
export function createItemFromFormData(vue, form) {
  const item = { ...form };
  item.unloadingFromTime = form.unloadingTimeRange && form.unloadingTimeRange.startTime;
  item.unloadingUntilTime = form.unloadingTimeRange && form.unloadingTimeRange.endTime;
  delete item.unloadingTimeRange;
  return item;
}

export function createFormDataFromItem(vue, item) {
  const form = { ...item };
  form.unloadingTimeRange = {
    startTime: item.unloadingFromTime,
    endTime: item.unloadingUntilTime
  };
  return form;
}
